module.exports = __webpack_public_path__ + "static/img/ic_kindgarden@2x.61bd3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_kindgarden@2x.png
// module id = neAd
// module chunks = 1